import { render } from "./StatutPage.vue?vue&type=template&id=1ec64f8b"
import script from "./StatutPage.vue?vue&type=script&lang=js"
export * from "./StatutPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__